<template>
<div>
  <div class="head-action">
    <div v-if="userReady && settingReady" class="widget-setting" @click.stop="toggleSetting">
      <v-icon name="cog" scale="1.1" />
    </div>

    <div class="minimize" @click="shrink">
      <img src="../../assets/img/x.svg"/>
      <!-- <i class="minimize-icon"></i> -->
    </div>

    <ul class="widget-setting-dropdown"
      :class="[openedSetting ? 'visible' : 'invisible']"
      v-clickaway="hideSetting" v-if="settingView == 'menu'">
        <li @click.stop.prevent="toggleSound">
          <v-icon name="volume-down" class="volume widget-setting-icon" />
          {{ $t("sound") }}
          <label class="switch">
            <input type="checkbox" v-model="enabledSound" />
            <div class="circle round"></div>
          </label>
        </li>
        <li @click.stop.prevent="toggleNotify">
          <v-icon name="bell" class="widget-setting-icon" />
          {{ $t("notify") }}
          <label class="switch">
            <input type="checkbox" v-model="pushNotification" />
            <div class="circle round"></div>
          </label>
        </li>

        <!-- <li @click.stop.prevent="toggleEmailTranscript">
          <v-icon name="envelope" class="widget-setting-icon" />
          {{ $t("email_transcript") }}
          <label class="switch">
            <input type="checkbox" v-model="enabledEmailTranscript" />
            <div class="circle round"></div>
          </label>
        </li> -->

        <li @click.stop.prevent="showUserInfo">
          <v-icon name="info-circle" class="widget-setting-icon" />
          {{ $t("contact_detail") }}
        </li>

        <li v-if="convoId && !isEndedConvo" @click.stop.prevent="endConversation">
          <v-icon name="power-off" scale="0.9" class="widget-setting-icon"/>
          {{ $t("end_chat") }}
        </li>
    </ul>
    <ul v-if="settingView === 'user-info'" class="widget-setting-dropdown widget-setting-dropdown-contact edit-form" v-clickaway="hideSetting">
      <li v-if="!isSavedContact">
        <strong>{{ $t('contact_detail') }}</strong>
      </li>
      <li v-else class="saved-contact">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style="fill: #07B977;">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M17.2559 4.4107C17.5814 4.73614 17.5814 5.26378 17.2559 5.58922L8.08926 14.7559C7.76382 15.0813 7.23618 15.0813 6.91074 14.7559L2.74408 10.5892C2.41864 10.2638 2.41864 9.73614 2.74408 9.4107C3.06951 9.08527 3.59715 9.08527 3.92259 9.4107L7.5 12.9881L16.0774 4.4107C16.4028 4.08527 16.9305 4.08527 17.2559 4.4107Z"/>
        </svg>
        <strong>{{ $t('saved_contact') }}</strong>
      <li>
        <input type="text" :placeholder="$t('fullname')" class="text" maxlength="100" v-model.trim="fullname" @focus="onFocusFormContact"/>
      </li>
      <li>
        <input type="text" :placeholder="$t('email')" class="text" maxlength="100" v-model.trim="email" :class="{error: invalidEmail}" @focus="onFocusFormContact"/>
      </li>
      <li>
        <input type="text" :placeholder="$t('phones')" class="text" maxlength="100" v-model.trim="phone" @focus="onFocusFormContact"/>
      </li>
      <li class="button-third-party">
        <span>with </span>
        <a @click="openAuthWindow('facebook')" href="javascript:void(0)" class="fa-facebook-square"><v-icon name="brands/facebook-square" /></a>
        <a @click="openAuthWindow('google')" href="javascript:void(0)" class="fa-google-square"><v-icon name="brands/google-plus-square" /></a>
      </li>
      <li v-if="isSavedContact">
        <a href="javascript:void(0)" class="buttons cancel" @click.stop.prevent="hideSetting">{{ $t("close") }}</a>
      </li>
      <li v-else>
        <a href="javascript:void(0)" class="buttons cancel" @click.stop.prevent="hideSetting">{{ $t("cancel") }}</a>
        <a href="javascript:void(0)" style="margin-right: 12px;" class="buttons save color-theme-default" :class="{disable: !fullname && !email && !phone}" @click.stop.prevent="updateUser">{{ $t("save") }}</a>
      </li>
  </ul>
  </div>

</div>
</template>

<script>
import * as utils from '../utils'
import { mapState } from 'vuex'
import eventHub from '../lib/hub'
import storage from '../lib/storage'
import store from '../store'
const objectPath = require('object-path')

export default {
  name: 'setting',

  data () {
    const user = store.state.user
    const widgetSetting = store.state.widgetSetting

    return {
      openedSetting: false,
      enabledEmailTranscript: widgetSetting.send_transcript,
      enabledSound: widgetSetting.sound_enabled,
      settingView: 'menu', // menu | user-info | user-info-social | user-info-form
      fullname: this.findUserAttribute(user.attributes, 'fullname'),
      email: this.findUserAttribute(user.attributes, 'emails'),
      phone: this.findUserAttribute(user.attributes, 'phones'),
      parentWindow: null,
      popupWindow: null,
      isSavedContact: false,
      invalidEmail: '',
      timeoutSaved: null
    }
  },

  computed: {
    ...mapState([
			'widgetSetting',
			'fcmToken',
      'userReady',
      'settingReady',
      'user',
    ]),

		pushNotification() {
			return !!this.fcmToken && this.widgetSetting.desktop_notification
		},

    convoId () {
      return this.$route.params.convoId || ''
    },

    userAttribute () {
      return this.user.attributes
    },

    isEndedConvo () {
      const convoId = this.$route.params.convoId || ''
      const convo = store.getters.getConvoById(convoId)
      if (convo && convo.id && convo.state === 'ended') {
        return true
      }
      return false
    }
  },

  watch: {
    user (data) {
      this.fullname = this.findUserAttribute(this.user.attributes, 'fullname')
      this.email = this.findUserAttribute(this.user.attributes, 'emails')
      this.phone = this.findUserAttribute(this.user.attributes, 'phones')
    }
  },

  beforeDestroy () {
    window.removeEventListener('message', this._onMessage, false)
  },

  methods: {
    async endConversation () {
      const convoId = this.convoId

      if (!convoId || this.isEndedConvo) {
        return false
      }

      await store.dispatch('endConvo', { accountId: store.state.account.id, convoId })
      this.openedSetting = false
      this.$emit('formContact', this.openedSetting)
    },

    findUserAttribute (data, key) {
      if (!data) return ''
      let userInfo = data.find(attribute => attribute.key === key)
      if (userInfo && userInfo.key) return userInfo.text
      return ''
    },

    toggleSetting () {
      this.openedSetting = !this.openedSetting
      this.$emit('formContact', this.openedSetting)
      this.settingView = 'menu'
    },

    hideSetting () {
      utils.log('hide Setting')
      this.openedSetting = false
      this.settingView = 'menu'
      this.isSavedContact = false
      this.$emit('formContact', this.openedSetting)
      this.fullname = this.findUserAttribute(this.user.attributes, 'fullname')
      this.email = this.findUserAttribute(this.user.attributes, 'emails')
      this.phone = this.findUserAttribute(this.user.attributes, 'phones')
    },

    shrink () {
      // nếu đã đóng cửa sổ chat xuống --> không tự động mở lên khi có conversation mới
      storage.set('is_closed', true, 86400)
      eventHub.$emit('widget.shrank')
      this.$router.push({ name: 'chat-button' })
    },

    async toggleEmailTranscript () {
      utils.log('toggle Email Transcript')
      this.enabledEmailTranscript = !this.enabledEmailTranscript

      const setting = {
        send_transcript: this.enabledEmailTranscript
      }

      const accountId = store.state.account.id
      const userId = store.state.user.id

      await store.dispatch('updateWidgetSetting', { accountId, userId, setting })
    },

    async toggleSound () {
      this.enabledSound = !this.enabledSound

      const setting = {
        sound_enabled: this.enabledSound
      }

      const accountId = store.state.account.id
      const userId = store.state.user.id

      await store.dispatch('updateWidgetSetting', { accountId, userId, setting })
    },

    async toggleNotify () {
		const accountId = store.state.account.id
		const userId = store.state.user.id

      if (this.pushNotification) {
			await store.dispatch('updateWidgetSetting', { accountId, userId, setting:{desktop_notification: false} })
        return
      }
			let setting = {desktop_notification: true}
			await store.dispatch('updateWidgetSetting', { accountId, userId, setting })
      await store.dispatch('subscribePushNotification')
    },

    async updateUser () {
      const name = this.fullname
      const email = this.email
      const phone = this.phone

      const data = { name, email, phone }

      await this._updateUser(data)
    },

    async _updateUser ({ name, email, phone }) {
      utils.log('update User')

      const userId = store.state.user.id
      const accountId = store.state.account.id
      const data = { attributes: [] }

      this.invalidEmail = false

      if (!name && !email && !phone) {
        this.openedSetting = false
        return
      }

      if (name) {
        data.attributes.push({ key: 'fullname', text: name })
        this.fullname = name
      }

      if (email) {
        if(!utils.isEmail(email)) {
          this.invalidEmail = true
          return
        }
        data.attributes.push({ key: 'emails', text: email })
        this.email = email
      }

      if (phone) {
        data.attributes.push({ key: 'phones', text: phone })
        this.phone = phone
      }

      await store.dispatch('updateUser', { accountId, userId, data })

      this.fullname = this.findUserAttribute(this.user.attributes, 'fullname')
      this.email = this.findUserAttribute(this.user.attributes, 'emails')
      this.phone = this.findUserAttribute(this.user.attributes, 'phones')

      this.isSavedContact = true
      this.settingView = 'user-info'
      this.timeoutSaved = setTimeout(() => { this.hideSetting() }, 3000)
    },

    onFocusFormContact () {
      clearTimeout(this.timeoutSaved)
      this.isSavedContact = false
    },

    showUserInfo () {
      this.settingView = 'user-info'
    },

      openAuthWindow (provider) {
	  let url = ''
	  if (provider == 'google') {
		  url = `https://accounts.google.com/o/oauth2/auth?redirect_uri=${process.env.VUE_APP_GG_CALLBACK_URL}&response_type=code&client_id=${process.env.VUE_APP_GG_CLIENT_ID}&scope=https://www.googleapis.com/auth/userinfo.email+https://www.googleapis.com/auth/userinfo.profile&access_type=offline`
	  } else if (provider == 'facebook') {
		  url = `https://www.facebook.com/v4.0/dialog/oauth?client_id=${process.env.VUE_APP_FB_APP_ID}&redirect_uri=${process.env.VUE_APP_FB_CALLBACK_URL}`
	  }

      const popup = window.open(url)
      this.popupWindow = popup
    },

    async _onMessage (event) {
		const _this = this
		let data = {}
		try {
			data = JSON.parse(event.data)
		} catch (err) {}
        utils.log('on message:', data)

      if (data.type === 'authenticated') {
        _this.fullname = data.name
        _this.email = data.email

        await _this._updateUser({
          name: data.name,
          email: data.email
        })

		_this.popupWindow.postMessage('close', '*')
      }
    },
  },
  mounted () {
    let menus = ['menu', 'user-info', 'user-info-social', 'user-info-form']// user-info-social, user-info-form deprecate but keep to compatible with api

    eventHub.$on('widget.openSetting', (navigationName = 'menu') => {
      this.$nextTick(() => {
        this.openedSetting = true
        if (menus.indexOf(navigationName) !== -1) {
          if (navigationName == 'menu') {
            this.settingView = 'menu'
            return
          }
          this.settingView = 'user-info'
        }
      })
    })

    window.addEventListener('message', this._onMessage, false)
  }
}
</script>
